module.exports = __webpack_public_path__ + "img/sales-by-source.6060fd54.png";